import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DelegatingMutableSet$iterator$1Class;
function DelegatingMutableSet$iterator$1() {
  if (DelegatingMutableSet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.m4n_1 = this$0;
        this.l4n_1 = this$0.n4n_1.u1();
      }
      v1() {
        return this.l4n_1.v1();
      }
      w1() {
        return this.m4n_1.o4n_1(this.l4n_1.w1());
      }
      u6() {
        return this.l4n_1.u6();
      }
    }
    initMetadataForClass($);
    DelegatingMutableSet$iterator$1Class = $;
  }
  return DelegatingMutableSet$iterator$1Class;
}
var DelegatingMutableSetClass;
function DelegatingMutableSet() {
  if (DelegatingMutableSetClass === VOID) {
    class $ {
      constructor(delegate, convertTo, convert) {
        this.n4n_1 = delegate;
        this.o4n_1 = convertTo;
        this.p4n_1 = convert;
        this.q4n_1 = this.n4n_1.v2();
      }
      r4n(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().m2(collectionSizeOrDefault(_this__u8e3s4, 10));
        var _iterator__ex2g4s = _this__u8e3s4.u1();
        while (_iterator__ex2g4s.v1()) {
          var item = _iterator__ex2g4s.w1();
          var tmp$ret$0 = this.p4n_1(item);
          destination.n2(tmp$ret$0);
        }
        return destination;
      }
      s4n(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().m2(collectionSizeOrDefault(_this__u8e3s4, 10));
        var _iterator__ex2g4s = _this__u8e3s4.u1();
        while (_iterator__ex2g4s.v1()) {
          var item = _iterator__ex2g4s.w1();
          var tmp$ret$0 = this.o4n_1(item);
          destination.n2(tmp$ret$0);
        }
        return destination;
      }
      v2() {
        return this.q4n_1;
      }
      t4n(element) {
        return this.n4n_1.n2(this.p4n_1(element));
      }
      n2(element) {
        return this.t4n((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      u4n(elements) {
        return this.n4n_1.z2(this.r4n(elements));
      }
      z2(elements) {
        return this.u4n(elements);
      }
      f5() {
        this.n4n_1.f5();
      }
      v4n(element) {
        return this.n4n_1.y2(this.p4n_1(element));
      }
      y2(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.v4n((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      w4n(elements) {
        return this.n4n_1.v4(this.r4n(elements));
      }
      v4(elements) {
        return this.w4n(elements);
      }
      s1() {
        return this.n4n_1.s1();
      }
      u1() {
        return new (DelegatingMutableSet$iterator$1())(this);
      }
      hashCode() {
        return hashCode(this.n4n_1);
      }
      equals(other) {
        var tmp;
        if (other == null) {
          tmp = true;
        } else {
          tmp = !isInterface(other, KtSet());
        }
        if (tmp)
          return false;
        var elements = this.s4n(this.n4n_1);
        var tmp_0;
        if (other.v4(elements)) {
          // Inline function 'kotlin.collections.containsAll' call
          tmp_0 = elements.v4(other);
        } else {
          tmp_0 = false;
        }
        return tmp_0;
      }
      toString() {
        return toString(this.s4n(this.n4n_1));
      }
    }
    initMetadataForClass($, 'DelegatingMutableSet', VOID, VOID, [KtMutableSet()]);
    DelegatingMutableSetClass = $;
  }
  return DelegatingMutableSetClass;
}
//region block: exports
export {
  DelegatingMutableSet as DelegatingMutableSet198sgh8jelkh1,
};
//endregion

//# sourceMappingURL=DelegatingMutableSet.mjs.map
